import {
  Checkbox, Divider, Message, MessageHeader,
} from '@mairistem/composants';
import React from 'react';

interface ModalSuperUserValidationProps {
  onChange: (data: boolean) => void;
}

const ModalSuperUserValidation = ({ onChange }: ModalSuperUserValidationProps) => (
  <>
    <Divider />
    <Message negative>
      <MessageHeader>Action super-utilisateur</MessageHeader>
      <p>{'Cette procédure sort du cadre habituel de l\'ordonnancement'}</p>
      <Checkbox
        label="J'ai compris."
        onChange={(_event, data) => onChange(data.checked)}
        data-testid="superUserValidationCheckbox"
      />
    </Message>
  </>
);

export default ModalSuperUserValidation;
